// Pack-animal storage window (M19 remainder). The same generic container machinery
// as a chest, over a donkey's or mule's saddlebags instead of a block entity.
// Client-only (ENG-1).
import { packSlots, type MountPack } from '../../../sim/game/containers/mount_storage';
import { maxStackFn, playerRefs, playerRows } from './crafting';
import { openWindow, refRange, returnToInventory, type SlotRef, type WindowConfig } from './container';
import type { Game } from '../../boot';

/** Open a chested pack animal's bags. `title` names the animal so two donkeys in
 *  a train are not indistinguishable windows. */
export function openMountStorage(game: Game, pack: MountPack, title: string): () => void {
  const slots = packSlots(pack, maxStackFn(game.registries));
  const packRefs = refRange(slots, 0, pack.items.length, undefined, 'pack');
  const pr = playerRefs(game.playerState.inventory);
  const packSet = new Set<object>([slots]);

  // 15 slots read as 3 rows of 5, the way Minecraft lays a donkey's bags out.
  const perRow = 5;
  const rows: (SlotRef | null)[][] = [];
  for (let r = 0; r * perRow < packRefs.length; r++) rows.push(packRefs.slice(r * perRow, r * perRow + perRow));
  rows.push([null]); // gap before the player panel

  const cfg: WindowConfig = {
    title,
    layout: [...rows, ...playerRows(pr)],
    quickTargets: (ref) => (packSet.has(ref.slots) ? [...pr.storage, ...pr.hotbar] : packRefs),
    onClose: (cursor) => returnToInventory(game, [cursor]),
  };
  return openWindow(game, cfg);
}
